import packageJSON from "../package.json";
import { Route, Switch } from "wouter";
import { ModalPortal } from "components/AnimalModal/ModalPortal";
import { Game } from "./components/Game/Game";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import { AdminPage } from "components/AdminPage/AdminPage";
import { RulesPage } from "components/RulesPage/RulesPage";
import { MobileWarningGate } from "components/MobileWarningGate/MobileWarningGate";
import { useT } from "i18n/I18nProvider";

function App() {
  const t = useT();
  useEffect(() => {
    document.title = t("app.title", {
      version: packageJSON.version,
    });
  }, [t]);
  return (
    <Switch>
      <Route path="/admin">
        <div>
          <AdminPage />
          <ToastContainer />
        </div>
      </Route>
      <Route path="/rules" component={RulesPage} />
      <Route path="/">
        <div>
          <MobileWarningGate>
            <Game />
          </MobileWarningGate>
          <ModalPortal />
          <ToastContainer />
        </div>
      </Route>
    </Switch>
  );
}

export default App;
